import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaBuilding,
  FaChartArea,
  FaChartLine,
  FaUser
} from 'react-icons/fa';

// Import components
import VentesStatistiques from '../Dashboard/VentesStatistiques';
import MouvementSoldeClient from '../MouvementSolde/MouvementSoldeClient';
import MouvementSoldeFournisseur from '../MouvementSolde/MouvementSoldeFournisseur';
import AchatsStatistiques from '../Dashboard/AchatsStatistiques';
import MouvementSoldeCommercial from '../MouvementSolde/MouvementSoldeCommercial';
import MouvementSoldeChantier from '../MouvementSolde/MouvementSoldeChantier';

const ReportsModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'reports',
    title: t('modules.reports.title'),
    description: t('modules.reports.description'),
    icon: FaChartArea,
    color: '#e83e8c',
    menuItems: [
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/reports-module/sales" replace />} />
        
        
      </Routes>
    </ModuleLayout>
  );
};

export default ReportsModule;
